<template>
  <modal name="userinput" height="auto" :width="480" :pivotX="windowWidth > 550 ? 0 : 0.5" :pivotY=".15" @before-open="assignParams">

    <aside class="window warning-message">
      <header class="window__header">
        <h1 class="window__title">{{ modalTitle }}</h1>
        <p class="window__description">
          {{ messageText }}
        </p>
      </header>
      <section class="window__content">
        <div class="window__input input input--flow">
          <input class="input__field" :type="fieldType" :placeholder="fieldPlaceholder" v-model="fieldValue" />
        </div>
      </section>

      <footer class="window__footer">
        <span class="window__button button button--primary button--large" v-on:click="confirm">{{ buttonText }}</span>
        <span class="window__link link link--secondary" v-on:click="hide">Cancel</span>
      </footer>
    </aside>

  </modal>
</template>

<script>
  export default {
    name: 'UserInput',
    methods: {
      assignParams (event) {
        this.callback = event.params.callback;
        this.messageText = event.params.messageText;
        this.buttonText = event.params.buttonText;
        this.fieldType = event.fieldType;
        this.fieldPlaceholder = event.params.fieldPlaceholder;
        this.modalTitle = event.params.modalTitle;
      },
      hide () {
        this.$modal.hide('userinput')
      },
      confirm () {
        this.$modal.hide('userinput')
        this.callback(this.fieldValue)
      }
    },
    mounted() {
      window.onresize = () => {
        this.windowWidth = window.innerWidth
      }
    },
    data () {
      return {
        messageText: null,
        buttonText: null,
        fieldType: null,
        fieldPlaceholder: null,
        modalTitle: null,
        fieldValue: '',
        windowWidth: window.innerWidth
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/modals/UserInput.vue